/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon20Regular = forwardRef('DivideCircleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.75 9.25a.75.75 0 1 0 0 1.5h6.5a.75.75 0 1 0 0-1.5h-6.5Z" }),
        React.createElement("path", { d: "M11.25 6.748a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
        React.createElement("path", { d: "M10 14.502a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
